define('apps/admin/views/products-search-results',[
        'njs!apps/admin/templates/includes/_products_search_results(params:tmpl=admin/main/includes/_products_search_results.html)',
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "template": template,

            "tagName": "table",

            "className": "comet-data-table",

        });
});

